import { ChangeDetectorRef, Component, OnInit, OnDestroy } from '@angular/core';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { Router } from '@angular/router';
import { ApiService } from '../Services/api.service';
import { AuthService } from '../Services/auth.service';
import { HttpClientModule } from '@angular/common/http';
import { ToastModule } from 'primeng/toast';
import { RippleModule } from 'primeng/ripple';
import { ProvidersUser } from '../Models/User.model';
import { ToastService } from '../Services/toast.service';
import { TranslationService } from '../Services/translation.service';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DropdownModule } from 'primeng/dropdown';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { MaterialModule } from '../material';
import { CheckboxModule } from 'primeng/checkbox';
import { NotificationService } from '../Services/notification.service';
import { version, buildDate, gitCommit, fullVersion } from '../../environments/version';
import { Subscription } from 'rxjs';
import { environment } from '../../environments/environment';
import { A11yModule } from "@angular/cdk/a11y";

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    InputTextModule,
    PasswordModule,
    FormsModule,
    ButtonModule,
    HttpClientModule,
    ReactiveFormsModule,
    CommonModule,
    TranslateModule,
    DropdownModule,
    MaterialModule,
    CheckboxModule,
    ProgressSpinnerModule,
    A11yModule
],
  providers: [ApiService, ToastService, TranslateService , NotificationService],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent implements OnInit, OnDestroy {
  username: string = '';
  password: string = '';
  errorMessage: string = '';
  appVersion = version;
  appBuildDate = buildDate;
  appGitCommit = gitCommit;
  appFullVersion = fullVersion;
  rememberme: boolean = false;
  providerTypeId: number[] = [];
  isLoading = false;
  selectedLanguage = this.translationService.getCurrentLanguage();
  translationsLoading = true;
  private translationSubscription: Subscription = new Subscription();
  printTemplate = environment.printTemplate


  constructor(private router: Router,
    private apiService: ApiService<ProvidersUser>,
    private authService: AuthService,
    private toastService: ToastService,
    private translateService: TranslateService,
    public translationService: TranslationService,
    private cdr: ChangeDetectorRef,
    private notificationService: NotificationService
  ) { }

  ngOnInit() {
    this.translationSubscription = this.translationService.isLoading$.subscribe(
      (loading) => {
        this.translationsLoading = loading;
        this.cdr.detectChanges();
      }
    );
  }

  ngOnDestroy() {
    if (this.translationSubscription) {
      this.translationSubscription.unsubscribe();
    }
  }

  languages = [
    { code: 'en', name: 'English' },
    { code: 'ar', name: 'العربية' }
  ];

  public getFlag(code: string) {
    return code === 'en' ? 'https://flagcdn.com/w20/gb.png' : 'https://flagcdn.com/w20/ly.png';
  }

  public changeLanguage(lang: string) {
    this.translationService.setLanguage(lang);
    this.selectedLanguage = lang;
  }

  public Onlogin(form: NgForm) {
    form.control.markAllAsTouched();
    if (!form.valid) {
      this.errorMessage = 'Username and password are required!';
      return;
    }
    this.isLoading = true;
    this.cdr.detectChanges();
    const loginData: ProvidersUser = {
      uName: this.username,
      uPass: this.password,
      rememberMe: this.rememberme
    };
    this.apiService.create('authenticate', loginData).subscribe({
      next: (response: any) => {
       
        if (response?.isRequestSuccessful === true) {
          const token = response?.successResponse?.token;
          const pid = response?.successResponse?.providersUser?.providerID;
          const username = response?.successResponse?.providersUser?.uName;
          const providerTypeId = response?.successResponse?.providersUser?.providerTypeId || [];
          const providerPermissions = response?.successResponse?.providersUser?.providerTypeActionPermissions || [];
          const sidebarMenu = response?.successResponse?.sidebarMenu;
          const uID = response?.successResponse?.providersUser?.uID;
          
          this.authService.setToken(token , this.rememberme)
          this.authService.setCurrentUserPID(pid);
          this.authService.setUserName(username);
          this.authService.setProviderTypeId(providerTypeId);
          this.authService.setPermissions(providerPermissions);
          this.authService.setSidebarMenu(sidebarMenu);
          this.authService.setUserID(uID);
          if(sidebarMenu && sidebarMenu.length > 0) {
            this.translateService.get('toast.loginsuccessfull').subscribe(text => {
              this.toastService.showSuccess(text);
            });
            this.router.navigate(['/portal']);
          } else {
            this.isLoading = false;
            this.translateService.get('toast.permissionsmissing').subscribe(text => {
              this.toastService.showError(text);
            });
            this.logout();
          }
        } else {
          this.toastService.showError(response.errorDetail?.errorReason || "Login failed. Please try again.");
        }
      },
      error: (err) => {
        this.isLoading = false;
        this.translateService.get('toast.loginfailed').subscribe(text => this.toastService.showError(text));

      },
      complete: () => {
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    });
  }

  logout() {
    this.authService.logout()
  }


}
